var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-icons",
    transform: "translate(-530.000000, -427.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0:-Base-/-Icons-/-arrow-right-Copy-6",
    transform: "translate(530.000994, 427.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74865203,15.1548832 L17.0213305,0.879858322 C18.1945687,-0.293286107 20.0999077,-0.293286107 21.273146,0.879858322 L23.1221696,2.73028975 C23.2676511,2.87670989 23.3943608,3.03486241 23.5069917,3.20146225 C24.276636,4.36719181 24.1499263,5.95200209 23.1221696,6.97975883 L8.84620606,21.2510294 C8.78519767,21.3120378 8.72418928,21.3308096 8.65848794,21.4293616 C8.20796443,21.8282626 7.67296778,22.0816821 7.09104158,22.292865 L1.44401106,23.9541704 C1.0488644,24.0714942 0.621336369,23.9635563 0.329903979,23.6303566 C0.0384622021,23.3816301 -0.0704987842,22.9545714 0.0457925949,22.5556703 L1.70681643,16.9100477 C1.90204328,16.2483413 2.26011561,15.6429503 2.74865203,15.1548832 L2.74865203,15.1548832 Z M3.86792136,17.5435964 L2.78948073,21.2134857 L6.45749291,20.1341065 C6.71560533,20.0449404 7.03003319,19.880687 7.25529495,19.6601182 L17.9739999,8.93672029 L15.0221324,5.98485276 L4.34144033,16.7457943 C4.31375191,16.7739521 4.28700208,16.8021098 4.26119083,16.8349604 C4.08004284,17.0367574 3.94535509,17.280791 3.86792136,17.5435964 L3.86792136,17.5435964 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.0ac73690aa1a5992c67795c257a63a52.svg";
export { ForwardRef as ReactComponent };